import React from "react";
import { enterpriseViewModel } from "common/viewModels";
import * as domain from "common/domain";
import Watermark from "components/Watermark";

const FarmEntRsu = ({ farm, budget, refData }) => {
    const enterprises = enterpriseViewModel(farm, budget, refData);
    const { currentResults = {} } = budget;
    const { animalResults = {} } = currentResults;

    return (
        <React.Fragment>
            {enterprises.length === 0 && "There are no animal enterprises on this farm."}
            {enterprises.length > 0 && (
                <div className="Table Table-Compressed">
                    <Watermark />
                    <table className="Calendar">
                        <thead>
                            <tr className="Calendar-months">
                                <th className="Calendar-title">Name</th>
                                {domain.farmYear.map((m, i) => (
                                    <th key={i} className="u-textCenter">
                                        {m.substring(0, 3)}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {enterprises.map((e, i) => {
                                const { sources = {} } = animalResults[e.id] || {};
                                return (
                                    <tr key={i}>
                                        <td data-width="25" key={"title"}>
                                            <span className="u-flex u-flexAlignItemsCenter">
                                                {e.icon && <img id={`calendar.titleIcon.${e.id}`} src={e.icon} className="u-mr-xs" width="35" height="35" alt={e.title} />}
                                                <span className="FarmTable-value">
                                                    <span>{e.enterpriseType}</span>
                                                </span>
                                            </span>
                                        </td>
                                        {domain.farmYear.map((m, x) => {
                                            let mTotal = 0;
                                            Object.keys(sources).forEach((st, i) => {
                                                const stMonth = sources[st].produced.find((ms) => ms.month === m) || { proportion: 0, perAnimal: 0, value: 0 };
                                                mTotal += stMonth.perAnimal;
                                            });
                                            return (
                                                <td key={x} className="u-textCenter">
                                                    {mTotal}
                                                </td>
                                            );
                                        })}
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            )}
        </React.Fragment>
    );
};

export default FarmEntRsu;
